import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { useSelector } from 'react-redux';
import store from './store';
import './App.css';
import MainImage from './Components/MainImage/MainImage';
import MainText from './Components/MainText/MainText';
import FabMenu from './Components/MainButton/MainButon';
import ImageUploadFab from './Components/ImageUploader/ImageUploader';
import SwipeableBottomSheet from './Components/SwipeableBottomSheet/SwipeableBottomSheet';
import ThemeToggle from './Components/ThemeToggle/ThemeToggle';
import UrlParamsHandler from './Components/UrlParamsHandler/UrlParamsHandler';
import TokenRoute from './Components/TokenRoute/TokenRoute';
import UploadProgress from './Components/UploadProgress/UploadProgress';
import LocalContentSync from './Components/LocalContentSync/LocalContentSync';
import {
  selectAllUrlParams,
  selectEntryError,
  selectEntryLoadState,
  selectIsMockMode,
} from './store/slices/urlParamsSlice';

function AppContent() {
  const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);

  const handleUploadClick = () => {
    // Trigger the image upload button click
    const uploadButton = document.querySelector('[data-upload-trigger]');
    if (uploadButton) {
      uploadButton.click();
    }
  };

  const event = useSelector(selectAllUrlParams);
  const entryLoadState = useSelector(selectEntryLoadState);
  const entryError = useSelector(selectEntryError);
  const isMockMode = useSelector(selectIsMockMode);
  const theme = event?.templateId || event?.theme || 'event';
  const isRestaurantTheme = theme === 'restaurant';
  
  // Theme toggle in mock/demo or when no real event is loaded
  const isDevelopmentMode = isMockMode || !event?.eventId || !event?.isInitialized;

  const buttonContainerClass = isRestaurantTheme 
    ? 'restaurant-buttons-container'
    : 'top-right-button';

  // Lightweight route handling without react-router:
  // `/t?token=<qrToken>` verifies QR then redirects to `/?<event params>`.
  if (window.location.pathname === '/t') {
    return <TokenRoute />;
  }

  return (
    <>
      <UrlParamsHandler />
      <div className="privacy-help-container">
        <button
          type="button"
          className="privacy-help-icon"
          aria-label="Privacy information"
          onClick={() => setShowPrivacyPopup((prev) => !prev)}
        >
          ?
        </button>
        {showPrivacyPopup && (
          <div className="privacy-help-popup" role="dialog" aria-label="Privacy info">
            <p>
              الصور والتعليقات المعروضة هنا يراها فقط صاحب الحدث/المطعم. يتم حفظ المحتوى بشكل آمن
              لحماية الخصوصية.
            </p>
            <p>
              Photos and reviews are visible only to the event/restaurant owners. Your content is
              stored securely to protect privacy.
            </p>
          </div>
        )}
      </div>
      {entryLoadState === 'loading' ? (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <p style={{ margin: 0, color: '#555', fontSize: 16 }}>Loading event…</p>
        </div>
      ) : entryLoadState === 'error' ? (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 16, padding: 20, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', textAlign: 'center' }}>
            <h2 style={{ margin: 0, marginBottom: 10, fontSize: 18, color: '#2c3e50' }}>Event link error</h2>
            <p style={{ margin: 0, color: '#666', lineHeight: 1.5 }}>{entryError}</p>
          </div>
        </div>
      ) : (
        <div className="App">
          <LocalContentSync />
          {isMockMode && (
            <div className="mock-mode-banner" role="status">
              وضع تجريبي — Demo mode
            </div>
          )}
          {isDevelopmentMode && <ThemeToggle />}
          <MainImage/>
          <MainText/>
          <SwipeableBottomSheet onUploadClick={handleUploadClick} />
          <div style={{ display: 'none' }}>
            <ImageUploadFab/>
          </div>
          <div className={buttonContainerClass}>
            <FabMenu/>
          </div>
          <UploadProgress />
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
